import styled from "styled-components";
import theme from "~/styles/theme";
import bgImage from "~/assets/img/bg.png";

export const Container = styled.div`
    width: 100%;
    position: relative;
    background-color: ${theme.palette.brand.terciary.light};
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (min-width: ${theme.breakpoints.values.md}px) {
        min-height: 450px;
    }
    
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        min-height: 400px;
        background: url(${bgImage}) bottom right no-repeat #b1dbf0;
    }
`;

export const BgImageElement = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
    }
`;

export const ImgHolder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    width: 100%;
    padding: 0;
    
    img {
        height: auto;
        display: block;
        max-width: 840px;
        width: 100%;
    }
    
`